//init foundation...
/*$.ready($(document).foundation());*/

var initDone = {
    iconizeLinks: false,
    externalLinks: false
    //,
    //slideshowResize:false
}

var queryParams = {};
var toggleBackupSwitchformouseleave = false, BackupSwitchhideDelayed, hideDelayed, ikuviotimeoutValue;
//

var searchIndexUrl = "https://emea04.find.episerver.net/YZGK6gKjXZgQgkgUGlJh6QIJKX3RxcIb/suomenpankki_index24178";//"http://es-eu-api02.episerver.net/ci5bgTmUUFRduvvfBHqtK36mzSlQviMF/cgifinlandtmp_index52014";
$(function () {
    //do we show cookie announcement?
    checkCookieConsent();

    // query string to object
    queryParams = $.getQueryParameters();

    // Init header search button
    $('#header-search-submit').on('click', function () { $('#header-search-form').submit(); })

    //hide responsive menu
    //TO BE DONE LESS CLUMSY!!
    $('.close-nav button').on('click', function () { $('.menu-toggler>button').click(); $(this).attr('aria-expanded', false); $('.menu-toggler>button').attr('aria-expanded', false) });

    // change images with svg-sources to svg-elements
    //replaceSvgImages();

    $(document).ajaxComplete(function () {// need to wait until ajax-calls are done before using resources
        if (!initDone.iconizeLinks) iconizeLinks();
        //link icons
        if (!initDone.externalLinks) externalLinks();
    });

    //if no image inside .main-image, remove margin from .page-body
    if (!$('.main-image>img').length) {
        $('.main-image').css('margin-bottom', '0');
        $('.page-body').css('margin-top', '0');
    }
    $('.toggler').on('click', function () {
        toggleBackupSwitchformouseleave = true;
        clearTimeout(hideDelayed);
        clearTimeout(BackupSwitchhideDelayed);
        $(this).parent().toggleClass('active');
        $(this).parent().siblings().removeClass('active');
        if ($(this).parent().parent().hasClass('level-2')) {
            $(this).parent().parent().siblings('.level-2').find('>li').removeClass('active');
        }
        if ($(this).parent().hasClass('current')) $(this).parent().toggleClass('current');

        BackupSwitchhideDelayed = setTimeout(function () {
            toggleBackupSwitchformouseleave = false;
        }, 1000);
    });
    $('.menu-toggler>button').on('click', function () {
        if ($('#nav-main:visible').length) {
            window.htmlscrolltop = $(window).scrollTop();
            $(window).scrollTop(0);
            $('body').css({
                'padding-top': '0'
            });
        } else {
            try {
                $(window).scrollTop(window.htmlscrolltop);
            } catch (e) { };
            $('body').css({
                'padding-top': ''
            });
        }
    });

    //split navigation to two columns via script
    //(css columns caused problems with mac/safari...)
    $('#nav-main .two-cols > .level-2').each(function () {
        $this = $(this);
        breakIndex = Math.ceil($this.find('>li').length / 2) - 1;
        if (breakIndex > 0) {
            $this.after('<ul class="level-2"></ul>');
        } else {
            $this.after('<span class="level-2">&nbsp;</span>');
        }
        
        $secondColumn = $this.next();
        $secondColumn.append($this.find('>li:gt(' + breakIndex + ')').detach());
    });
    // /nav splitting done

    initPanels();

    initQuickSearch();

    initShareButtons();

    //////$(window).on('resize', function () {
    //////    debounce(resizeEvents, 250);
    //////    //debounce(slideshowResizeEvents,250);//
    //////    clearTimeout(ikuviotimeoutValue);
    //////    ikuviotimeoutValue = setTimeout(function () { ikuviotimeout(); }, 1000);
    //////});

    resizeEvents();
    //slideshowResizeEvents();

    //calendar-page functionality
    calendarPage();

    //speeches-block functionality
    speechBlock();

    //eventlistfilter-block functionality
    eventListFilterBlock();

    //slideshow
    initSlideshow();

    //init lightbox stuff
    lightboxInit();

    addBordersToBlocks();

    //checkIframes for cookie consent
    CheckPageIframeCookieConsent();

    //gallery images heights on tabs
    if ($('.tabs-panel .profile-images').length) {
        //console.log('profile images on tab');
        $('.tabs-panel .profile-images').each(function () {
            var _this = this;
            $('#' + $(_this).closest('.tabs-panel').attr('aria-labelledby')).on('click', function () {
                $(_this).foundation('getHeightsByRow', function () { });
            });
        });
    }

    //////// add charts script if there are charts to draw and draw them
    //////if ($('.chart').length) $.getScript('https://www.gstatic.com/charts/loader.js', function () {
    //////    google.charts.load('current', { packages: ['corechart', 'line'] });//only line charts currently
    //////    google.charts.setOnLoadCallback(drawCharts);
    //////});

    //!!! REMOVE THIS ASAP !!!
    //!!! REMOVE THIS ASAP !!!
    //!!! REMOVE THIS ASAP !!!

    //////$('.frontpage-content .block').append('<hr class="onlyoneline">');
    //////$('.onlyoneline').hide();
    //////$('.block .block .onlyoneline').remove();

    //remove line from lowest block of each side
    //should be done after ajax, but done fast with timeout
    //setTimeout(function () {
    //    if (!$('.frontpage-content').length) return;
    //    var $lastleft = {}, $lastright = {};
    //    $('.frontpage-content').css('position', 'relative');
    //    $('.frontpage-content>.columns>.row>.block').each(function () {
    //        thisposleft = $(this).position().left;
    //        if (thisposleft == 0) {
    //            $lastleft = $(this);
    //        } else {
    //            $lastright = $(this);
    //        }
    //    });
    //    try {
    //        $lastleft.find('.onlyoneline').remove();
    //        $lastright.find('.onlyoneline').remove();
    //    } catch (e) { }

    //}, 2000);
    //////$('.onlyoneline').show();
    // /!!! REMOVE THIS ASAP !!!
    // /!!! REMOVE THIS ASAP !!!
    // /!!! REMOVE THIS ASAP !!!
});

function CheckPageIframeCookieConsent() {


    $(document).ready(function () {
        //cookie_cat_statistic
        //cookie_cat_marketing
        var marketingsites = ["youtube", "youtu.be", "slideshare"];
        var statisticalsites = ["panopto"];

        if (!CookieInformation.getConsentGivenFor('cookie_cat_marketing')) { 

            $("iframe").each(function () {
                var src = this.src;
                var srcCompare = src.toLowerCase();
                for (var i = 0; i < marketingsites.length; i++) {
                    if (srcCompare.indexOf(marketingsites[i]) > 0) {

                    
                        this.setAttribute('data-consent-src', src);

                        //if (window.epi) {
                        //    this.setAttribute('src', src);
                        //} else {

                        this.setAttribute('src', '');

                        //}
                        this.setAttribute('loading', 'lazy');
                        this.setAttribute('data-category-consent', 'cookie_cat_marketing');

                        // Get the generic consent element
                        var elem = document.querySelector('#generic-consent');

                        // Create a copy of it
                        var clone = elem.cloneNode(true);

                        // Update the ID and add a class

                        clone.setAttribute("data-category", "cookie_cat_marketing");
                        clone.classList.add("consent-placeholder");

                        // Inject it into the DOM
                        this.after(clone);

                        return;

                    }
               
                }

            });
        }
    });
}

function resizeEvents() {
    //console.log('resize');
    wWidth = $(window).width();
    spaceCookieConsent(true);
    if (wWidth <= 1024) {
        //console.log('window size: small or medium');
        //restore default function to dropdown links on small & medium screens
        //$('#nav-main .has-dropdown>a').unbind('click');
        //$('#page-content,#pagefooter').unbind('click');
        $('#nav-main .has-dropdown').off('mouseover,mouseout');
        $('#nav-main .dropdown').off('mouseover,mouseout');
        $('#nav-main .has-dropdown>a').off('touchend');
        $('.site-header-top').off('mouseover');

    }
    if (wWidth > 640 && wWidth <= 1024) {
        //console.log('window size: medium');
    }

    if (wWidth > 1024) {
        //*/console.log('window size: large');
        //*/megamenu's behaviour
        var showDelayed,
            layerShowDelay = 300,
            layerHideDelay = 600;
        $('#nav-main').on('mouseover focusin', '.has-dropdown',
            function () {
                //console.log('has-dropdown:mouseover');
                clearTimeout(hideDelayed);
                _this = this;
                setTimeout(function () {
                    $(_this).siblings().removeClass('show-dropdown');
                }, layerHideDelay);
                showDelayed = setTimeout(
                    function () {
                        $(_this).addClass('show-dropdown');
                    }, layerShowDelay);
            });
        $('#nav-main').on('mouseover focusin', '.dropdown',
            function () {
                //console.log('dropdown:mouseover');
                clearTimeout(hideDelayed);
            }
        );
        $('#nav-main').on('mouseout focusout', '.has-dropdown',
            function () {
                //console.log('has-dropdown:mouseout');
                clearTimeout(showDelayed);
            }
        );
        //
        $('#nav-main .follow-us').on('mouseover focusin',
            function () {
                //console.log('follow-us:mouseover');
                clearTimeout(hideDelayed);
            }
        );
        //
        $('#nav-main .dropdown').on('mouseleave focusout',
            function () {
                //console.log('dropdown:mouseleave');
                clearTimeout(hideDelayed);

                if (!toggleBackupSwitchformouseleave) {
                    _this = this;

                    hideDelayed = setTimeout(function () {
                        $(_this).parent().removeClass('show-dropdown')
                    }, layerHideDelay);
                }
            }
        );
        $('.site-header-top').on('mouseover', function () {
            //console.log('siteheadertop:mouseover');
            clearTimeout(hideDelayed);
            hideDelayed = setTimeout(function () {
                $('.level-1>.has-dropdown').removeClass('show-dropdown');
            }, layerHideDelay);
        });
        $('#nav-main .show-dropdown').on('mouseout focusout',
            function () {
                //console.log('show-dropdown:mouseout');

                if (!toggleBackupSwitchformouseleave) {
                    _this = this;
                    hideDelayed = setTimeout(function () {
                        $(_this).removeClass('show-dropdown')
                    }, layerHideDelay);
                }
            }
        );
        //*/

        //*/add touch event handler for displaying megamenu on large touchscreens
        // test this:
        $('#nav-main .has-dropdown>a').on('touchend', function (event) {
            $(this).on('click', function (event) { event.preventDefault(); });
            $(this).parent().siblings().removeClass('show-dropdown');
            $(this).parent().toggleClass('show-dropdown');
        });
        //*/

    }

}

// cookie consent helpers
function spaceCookieConsent(space) {
    //add/adjust/remove space needed for cookie consent message
    if (space && $('#cookie-consent:visible')) {
        $('body,.site-header').css('margin-top', $('#cookie-consent').height() + 'px');
    } else {
        $('body,.site-header').css('margin-top', 0);
    }
}
function consentToCookieUse() {
    // accept cookies
    document.cookie = "cookie-consent=true; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";
    $("#cookie-consent").remove();
    spaceCookieConsent(false);
}
function checkCookieConsent() {
    //remove cookie consent notice if cookie is set
    if (document.cookie.match('cookie-consent')) {
        $('#cookie-consent').remove();
        spaceCookieConsent(false);
    } else {
        $('#cookie-consent').removeClass('hide');
        spaceCookieConsent(true);
    }
}

function addBordersToBlocks() {
    $('.columns.one-third,.columns.half,.columns.two-thirds').each(function () {
        $(this).attr('class');
    });
}

function externalLinks() {
    //adds icon to external links
    //var extIconHtml = '<img src="/svg/external.svg" alt="" />';
    var currentDomain = location.hostname;
    $('a').not($('.utils a,.no-external-link-icon,.twitter .feed a,.some a,.some-btn, .slideshow a')).each(function () {
        $link = $(this);
        var a = new RegExp('((' + currentDomain + ')|(mailto:)|(ftp:))');
        if (!a.test(this.href) && $link.attr('href') != '' && $link.attr('href') != undefined) {
            if (!$link.find('img').length) {
                $link.addClass('external');
                //$link.append(extIconHtml);
            } else if ($link.hasClass('table-block') || $link.hasClass('bofcontenthighlight')) {
                $link.addClass('external');
            }
            if (!$link.is('[target]')) {
                $link.attr('target', '_blank');
            }
        }
    });
    initDone.externalLinks = true;
}

function replaceSvgImages() {
    // Replaces all images with class 'svg-replace' with corresponding svg-image
    // this is done so css may be applied also to svgs.
    // Img-tags must have the id of actual svg-element in data-graphic-id attribute
    $('img.svg-replace').each(function () {
        $i = $(this);
        src = $i.attr('src');
        if (!src.match(/.svg$/i)) return;
        outputSvg = '<svg width="' + $i.width() + '" height="' + $i.height() + '" class="svg-image ' + $i.attr('class') + '">';
        outputSvg += '<use href="' + $i.attr('src') + '#' + $i.attr('data-graphic-id') + '"></use>';
        outputSvg += '</svg>';
        $i.replaceWith(outputSvg);
    });
};
function injectSvgSourceFile(sourceFile) {
    // inject svg at the top of body and replace icons with svg-shapes
    $.get(sourceFile, function (data) {
        $('#svg-icons').html(data);
    }, 'html');
};

function iconizeLinks() {
    // change specified generated links' content to svg shapes
    if ($('#svg-icons').html() === '') return // check that the svg source is in place
    $('.iconize').each(function () {
        outputSvg = '<svg viewBox="0 0 100 100" class="icon-svg ' + $(this).attr('data-svg-icon') + '">';
        outputSvg += '<use href="#' + $(this).attr('data-svg-icon') + '"></use>';
        outputSvg += '</svg>';
        $(this).find('>a').html(outputSvg);
    });
    initDone.iconizeLinks = true;
};

function initPanels() {
    //collapsibles
    $('[data-collapsible-panel]').each(function () {
        _this = this;
        if ($(_this).is('[data-initially-open-on-large]') && $(window).width() > 1024) {
            $(_this).removeAttr('data-state-closed');
        }
        $(_this).find('[data-toggler]').on('click', function () {
            if ($(_this).attr('data-state-closed') === undefined) {
                $(_this).attr('data-state-closed', '');
            } else {
                $(_this).removeAttr('data-state-closed');
            }
        });
    });
}
// year selects page
function calendarPage() {
    if ($('#SelectYearDD').length < 1) return;
    selectYear = queryParams.y;
    if (selectYear != null) {
        $('#SelectYearDD').val(selectYear);
    }
};

// Aria-atomic attribute for all aria-live assertive elements
$(document).ready(function () {
    $('div[aria-live="assertive"]').attr('aria-atomic', 'true');
});




// year selects filter SpeechBlock
function speechBlock() {
    if ($('#SpeechYearDD').length < 1) return;
    selectYear = queryParams.speechYear;
    if (selectYear != null) {
        $('#SpeechYearDD').val(selectYear);
    }
};

// year selects filter EventListFilterBlock
function eventListFilterBlock() {
    if ($('#EventsYearDD').length < 1) return;
    selectYear = queryParams.eventsYear;
    if (selectYear != null) {
        $('#EventsYearDD').val(selectYear);
    }
};

function qs(key) {
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
    var match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)"));
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

function getSelectedYear(selectedYear, key, tabContent) {
    // selectedYear: select element (object)
    // key: url parameter name
    // tab: if content is in tabbed part, class to identify tab content
    var value = selectedYear.value;
    var url = window.location.href;
    //console.log(value);
    //console.log(tabContent);
    var positionParams = window.scrollY;
    url = addParameter(url, 'scroll', positionParams);
    if (tabContent != 'undefined') url = addParameter(url, 'tabContent', tabContent);
    window.location.href = addParameter(url, key, value);
}

function addParameter(url, param, value) {
    // Using a positive lookahead (?=\=) to find the
    // given parameter, preceded by a ? or &, and followed
    // by a = with a value after than (using a non-greedy selector)
    // and then followed by a & or the end of the string
    var val = new RegExp('(\\?|\\&)' + param + '=.*?(?=(&|$))'),
        parts = url.toString().split('#'),
        url = parts[0],
        hash = parts[1]
    qstring = /\?.+$/,
        newURL = url;

    //Encode value before inserting it to query.
    value = encodeURIComponent(value);

    // Check if the parameter exists
    if (val.test(url)) {
        // if it does, replace it, using the captured group
        // to determine & or ? at the beginning
        newURL = url.replace(val, '$1' + param + '=' + value);
    }
    else if (qstring.test(url)) {
        // otherwise, if there is a query string at all
        // add the param to the end of it
        newURL = url + '&' + param + '=' + value;
    }
    else {
        // if there's no query string, add one
        newURL = url + '?' + param + '=' + value;
    }

    if (hash) {
        newURL += '#' + hash;
    }

    return newURL;
}
// /calendar page

// search page
function setSearchDateQueryStringParams() {
    var param1 = $('#searchstartdate').val();
    var key1 = "start";
    var param2 = $('#searchenddate').val();
    var key2 = "end";
    var url = window.location.href;

    //console.log(param1);
    //console.log(param2);

    if (param1 != "" && param2 != "") {
        url = addParameter(url, key1, param1);
        url = addParameter(url, key2, param2);
        //console.log(url);
        window.location.href = url;
    }
    else if (param1 != "" && param2 == "") {
        //console.log("param1");
        var url = removeURLParameter(url, key2);
        window.location.href = addParameter(url, key1, param1);
    }
    else if (param1 == "" && param2 != "") {
        //console.log("param2");
        var url = removeURLParameter(url, key1);
        window.location.href = addParameter(url, key2, param2);
    }
    else {
        url = removeURLParameter(url, key1);
        url = removeURLParameter(url, key2);
        window.location.href = url;
    }
}

function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}
// /search page

// slideshow

function slideClassChange(entry) {
    //if (!initDone.slideshowResize) return;
    if (entry.attributeName != 'class') return;
    //if slide class changes...
    re1 = /mui-enter-active/;
    re2 = /is-active/;
    if (entry.oldValue.match(re1) && entry.newValue.match(re2)) {
        // ...test if the slide's entered to active state after animation and set timer-line to 100% so the transition can start.
        $cSlide = $(entry.target);
        $cSlide.find('.timer-line').css({
            'width': '100%'
        });
    } else {
        // If the slide is not ready or it's gone out, set the timer to zero.
        $(entry.target).find('.timer-line').css({
            'width': '0'
        });
    }
}
function slideshowResizeEvents() {
    //modify slideshow according to screen size
    var $slides = $('.orbit-slide');
    if ($slides.length < 1) return;
    wWidth = $(window).width();
    if (wWidth < 640) {
        $slides.each(function () {
            $(this).find('.slide-label').prepend($(this).find('.timer-line').detach());
        });
    } else {
        $slides.each(function () {
            $(this).find('.slide-footer>.row').prepend($(this).find('.timer-line').detach());
        });
    }
    $('.timer-line').css('width', '0');
    //initDone.slideshowResize = true;
}
function initSlideshow() {
    var $slides = $('.orbit-slide');

    $slides.each(function () {
        $(this).attrchange({
            //check if the slide is changing/changed for resetting of the timer line
            trackValues: true,
            callback: function (e) {
                slideClassChange(e);
            }
        });
    });
    $('.slideshow').each(function () {
        if ($(this).find('.orbit-slide').length < 2) {
            $(this).find('.button-row,.orbit-bullets').addClass('one-slide-only');
            $(this).find('.orbit-previous').addClass('one-slide-only');
            $(this).find('.orbit-next').addClass('one-slide-only');
        } else {
            $($(this).find('.orbit-slide')[0]).find('.timer-line').css('width', '100%');
        }
        $slideshow = $(this);
        $slideshow.find('.timer-line').css('transition-duration', $slideshow.attr('data-timer-delay') / 1000 + 's');
    });
}
// /slideshow
function initQuickSearch() {
    
    $("#search-query").autocomplete({
        source: function (request, response) {
            $.ajax({
                url: '/find_v2' + '/_autocomplete?prefix=' + encodeURIComponent(request.term) + '&size=5&tags=' + encodeURIComponent('language:' + $('html').attr('lang')),
                dataType: 'json', //jsonp -> json 25.3.2020
                contentType: 'application/json; charset=utf-8',
                success: function (data) {
                    response($.map(data.hits, function (item) {
                        return {
                            label: item.query,
                            value: item.query
                        };
                    }));
                }
            });
        },
        minLength: 2,
        open: function () {
            var inputWidth = $("#search-query").outerWidth().toString();
            $('.ui-autocomplete').css('width', inputWidth);
        },
        appendTo: "#header-search",
        select: function (event, ui) {
            $('#search-query').val(ui.item.value);
            $('#header-search-form').submit();
        }
    }).data("uiAutocomplete")._renderItem = function (ul, item) {
        $(ul).addClass("search-query-autocomplete");
        plainStr = $('#search-query').val();
        matchStr = '<span class="match">' + plainStr + '</span>';
        testRx = new RegExp(plainStr, 'gi');
        htmlStr = '<span>' + item.label.replace(testRx, matchStr) + '</span>';
        return $("<li></li>").data("item.autocomplete", item).append(htmlStr).appendTo(ul);
    }
}

// graph selects

// /graph selects
function drawCharts() {
    //console.log('fn drawCharts');
    exchangeRateCharts();
    euriborRateCharts();
}
// draw exchange rate charts
function exchangeRateCharts() {
    //console.log('fn exchangeRateCharts');
    if (!$('.exchange-rates').length) {
        //console.log('no exchange rates on page');
        return;
    }

    $('.exchange-rates .infographics').each(function () {
        var $infographic = $(this);
        //console.log('infographic!');
        var rates = {};
        $.ajax({
            url: $(this).attr('data-rates-json'),
            dataType: 'json',
            success: function (data) {
                rates = data.ExchangeRates;
                $infographic.find('.chart').each(function (result) {
                    currentCurrency = rates[$(this).attr('data-currency')];
                    var values = [];
                    for (count in currentCurrency) {
                        values.push([parseInt(count), currentCurrency[count].Value]);
                    }
                    drawMicroChart(values, $(this).attr('id'));
                });
            },
            error: function (e) {
                console.log('Chart data error!');
                console.log(e);
            }
        });
    });
}
// /draw exchange rate charts
// draw euribor rate charts
function euriborRateCharts() {
    //console.log('fn euriborRateCharts');
    if (!$('.interest-rates').length) {
        //console.log('no euribor rates on page');
        return;
    }

    $('.interest-rates .infographics').each(function () {
        var $infographic = $(this);
        if (!$infographic.find('.chart').length) return;
        $.ajax({
            url: $(this).attr('data-rates-json'),
            dataType: 'json',
            success: function (data) {
                $infographic.find('.chart').each(function (result) {
                    currentInterest = data[$(this).attr('data-interest')];
                    var values = [];
                    for (count in currentInterest) {
                        values.push([parseInt(count), currentInterest[count].Value]);
                    }
                    drawMicroChart(values, $(this).attr('id'));
                });
            },
            error: function (e) {
                console.log('Chart data error!');
                console.log(e);
            }
        });
    });
}
// /draw exchange rate charts

// draw microchart
// separate function as this is used in multiple occasions
function drawMicroChart(values, id, options) {
    if (options == 'undefined' || options == '' || options == false || options == 0 || options == null) {
        // without options, use defaults
        options = {
            width: '100%',
            height: 16,
            series: {
                0: { color: '#4e55a1' }
            },
            lineWidth: 1,
            tooltip: {
                trigger: 'none'
            },
            backgroundColor: 'transparent',
            chartArea: {
                left: 0,
                top: 0,
                width: '100%',
                height: '100%'
            },
            hAxis: {
                gridlines: {
                    count: 0
                },
                baselineColor: 'transparent'
            },
            vAxis: {
                gridlines: {
                    count: 0
                },
                baselineColor: 'transparent'
            }
        }
    }
    chartData = new google.visualization.DataTable();
    chartData.addColumn('number', '');
    chartData.addColumn('number', '');
    chartData.addRows(values);
    var chart = new google.visualization.LineChart(document.getElementById(id));
    chart.draw(chartData, options);
}
// /draw microchart

// responsive tables

//share buttons with snoobi tracking
function initShareButtons() {
    $('a.share').each(function () {
        $(this).on('click', function (event) {
            event.preventDefault();
            options = {
                url: $(this).attr('data-share-url'),
                height: $(this).attr('data-share-height'),
                width: $(this).attr('data-share-width'),
                snbPagename: $(this).attr('data-snb-pagename'),
                snbSection: $(this).attr('data-snb-section')
            }
            if (options.height === undefined) options.height = 570;
            if (options.width === undefined) options.width = 520;
            //snoobi.trackPageView(location.pathname, options.snbPagename, options.snbSection);
            window.open(options.url + encodeURIComponent(location.href), 'ShareDialog', 'width=' + options.width + ',height=' + options.height);
        });
    });
}

//debounce function
debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait || 200);
        if (callNow) {
            func.apply(context, args);
        }
    };
};

ikuviotimeout = function () {
    if ($('.listing.graphs').length > 0) {
        var wWidth1 = $(window).width();
        if (wWidth1 < 623) {
            $('.listing.graphs .graph-item').css('min-height', '');
            $('.listing.graphs .graph-item h5.ng-binding').css('height', '');
        }
        else {
            setTimeout('calculateHeighs()', 500);
        }
    }
};

function calculateHeighs() {
    $('.listing.graphs .graph-items-container ').each(function () {
        var h2height = 0, mvalue, tmpObj;
        var obj1, obj2, obj3, margin1, margin2, margin3, objCount = 0, highestcount = 0, thisheight, highesttitle;
        $(this).find('.graph-item').each(function (index, value) {
            if (!$(this).attr("data-titleheight")) {
                tmpObj = $(this).find('h5.ng-binding');
                h2height = Math.floor(tmpObj.height());
                h2height = (h2height / 25) * 27;
                mvalue = h2height;
                $(this).attr('data-titleheight', h2height);
            }
            else
                mvalue = parseInt($(this).attr('data-titleheight'));

            thisheight = mvalue + 25 + $(this).find('img').height() + 40 + 50;

            objCount++;

            if (objCount > 3) {
                obj1.css('min-height', highestcount + 'px!important');
                obj2.css('min-height', highestcount + 'px!important');
                obj3.css('min-height', highestcount + 'px!important');

                obj1.find('h5.ng-binding').css('height', '' + highesttitle + 'px');
                obj2.find('h5.ng-binding').css('height', '' + highesttitle + 'px');
                obj3.find('h5.ng-binding').css('height', '' + highesttitle + 'px');

                objCount = 1;
                obj1 = null, obj2 = null, obj3 = null;
                margin1 = 0, margin2 = 0, margin3 = 0;
                highestcount = 0;
                highesttitle = 0;
            }

            if (objCount == 1) {
                obj1 = $(this);
            }
            else if (objCount == 2) {
                obj2 = $(this);
            }
            else if (objCount == 3) {
                obj3 = $(this);
            }

            $(this).attr('data-objCount', objCount);

            if (thisheight > highestcount) {
                highestcount = thisheight;
                highesttitle = mvalue;
            }
        });
        if (highestcount) {
            if (obj1) {
                obj1.css('min-height', highestcount + 'px!important');
                obj1.find('h5.ng-binding').css('height', '' + highesttitle + 'px');
            }
            if (obj2) {
                obj2.css('min-height', highestcount + 'px!important');
                obj2.find('h5.ng-binding').css('height', '' + highesttitle + 'px');
            }
            if (obj3) {
                obj3.css('min-height', highestcount + 'px!important');
                obj3.find('h5.ng-binding').css('height', '' + highesttitle + 'px');
            }
        }
    });
}

$(function () {
    $(document).ready(function () {
        $("body").append('<div id="spinneroverlay"><div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div>');

        $("#spinneroverlay").click(function () {
            return false;
        });
    });
});

iSpinner = function (action) {
    if (action) { $("#spinneroverlay").show(); }
    else { $("#spinneroverlay").hide(); }
};

// Lightbox for graphs
var lightboxOne;
function lightboxIt() {
    try {
        lightboxOne.destroy();
    } catch (e) {
    }
    lightboxOne = $('[data-imagelightbox]').SimpleLightbox();
    $('.listing.graphs .figure').addClass('position-absolute');
}
function lightboxInit() {
    // select the target node
    var target = document.querySelector('.listing.graphs');
    //console.log(target);
    if (target == null) return;

    // create an observer instance
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            setTimeout(lightboxIt, 1000);
        });
    });
    // configuration of the observer:
    var config = { childList: true }
    // pass in the target node, as well as the observer options
    observer.observe(target, config);
}

/****************************/
var lightboxc;
$(function () {
    $(document).ready(function () {
        /*mp 21.2.2018 tilastot slideri*/

        if ($('.page-header .carouselblock ').length > 0) {
            $('.row.page-body.section-page ').addClass('fixSliderMargins');
        }
        //if ($('.popsliderlnk ').length > 0) {
        //    lightboxc = $('.popsliderlnk').simpleLightbox();
        //}
    });
});

/****************************/

/* **** */

/* cookie handling */
jQuery.cookie2 = function (name, value, options) {
    if (typeof value != 'undefined') { // set the cookie ( name , value )
        options = options || {};
        if (value === null) {
            value = '';
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString();
        }
        var path = options.path ? '; path=' + (options.path) : '';
        var domain = options.domain ? '; domain=' + (options.domain) : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else { // Get cookie (name)
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};

function getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.random();
}

/* **** */

/***************** JQUERY PLUGINS ETC. ***********************/
/************ NO OWN FUNCTIONS AFTER THIS LINE ***************/
/********** YES, DON'T WRITE ANYTHING AFTER THIS *************/
/*************************************************************/
/*********************** ...REALLY ***************************/
/*************************************************************/

// sticky header
/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
	---
	!Modiefied by SJ to fit current needs
*/
// JQUERY VERSION:

; (function ($, window, document, undefined) {
    'use strict';

    var elSelector = '.site-header',
        elClassNarrow = 'narrow',
        bodyClassNarrow = 'narrow-header',
        elNarrowOffset = 1,
        $element = $(elSelector);

    if (!$element.length) return true;

    var elHeight = 0,
        elTop = 0,
        $document = $(document),
        dHeight = 0,
        $window = $(window),
        wHeight = 0,
        wScrollCurrent = 0,
        wScrollBefore = 0,
        wScrollDiff = 0;

    $window.on('scroll', function () {
        elHeight = $element.outerHeight();
        dHeight = $document.height();
        wHeight = $window.height();
        wScrollCurrent = $window.scrollTop();
        wScrollDiff = wScrollBefore - wScrollCurrent;
        elTop = parseInt($element.css('top')) + wScrollDiff;
        $element.toggleClass(elClassNarrow, wScrollCurrent > elNarrowOffset); // toggles "narrow" classname
        $('body').toggleClass(bodyClassNarrow, wScrollCurrent > elNarrowOffset); // toggles document body's "narrow" classname

        if (wScrollCurrent <= 0) // scrolled to the very top; element sticks to the top
            $element.css('top', 0);

        else if (wScrollDiff > 0) // scrolled up; element slides in
            $element.css('top', elTop > 0 ? 0 : elTop);

        else if (wScrollDiff < 0) // scrolled down
        {
            if (wScrollCurrent + wHeight >= dHeight - elHeight)  // scrolled to the very bottom; element slides in
                $element.css('top', (elTop = wScrollCurrent + wHeight - dHeight) < 0 ? elTop : 0);

            //else // scrolled down; element slides out
            $element.css('top', Math.abs(elTop) > elHeight ? -elHeight : elTop);
        }

        wScrollBefore = wScrollCurrent;
    });
})(jQuery, window, document);

///// SIMPLE LIGHTBOX
/*
	By André Rinas, www.andreknieriem.de
	Available for use under the MIT License
*/

!function (a, b, c, d) { "use strict"; a.fn.SimpleLightbox = function (d) { var t, d = a.extend({ overlay: !0, spinner: !0, nav: !0, navText: ["&lsaquo;", "&rsaquo;"], captions: !0, captionDelay: 0, captionSelector: "img", captionType: "attr", captionsData: "title", captionPosition: "bottom", close: !0, closeText: "×", swipeClose: !0, showCounter: !0, fileExt: "png|jpg|jpeg|gif", animationSlide: !0, animationSpeed: 250, preloading: !0, enableKeyboard: !0, loop: !0, rel: !1, docClose: !0, swipeTolerance: 50, className: "simple-lightbox", widthRatio: .8, heightRatio: .9, disableRightClick: !1, disableScroll: !0, alertError: !0, alertErrorMessage: "Image not found, next image will be loaded", additionalHtml: !1, history: !0 }, d), h = (b.navigator.pointerEnabled || b.navigator.msPointerEnabled, 0), i = 0, j = a(), k = function () { var a = c.body || c.documentElement; return a = a.style, "" === a.WebkitTransition ? "-webkit-" : "" === a.MozTransition ? "-moz-" : "" === a.OTransition ? "-o-" : "" === a.transition && "" }, l = !1, m = [], n = function (b, c) { var d = a(c.selector).filter(function () { return a(this).attr("rel") === b }); return d }, o = d.rel && d.rel !== !1 ? n(d.rel, this) : this, k = k(), p = 0, q = k !== !1, r = "pushState" in history, s = !1, u = b.location, v = function () { return u.hash.substring(1) }, w = v(), x = function () { var b = (v(), "pid=" + (H + 1)), d = u.href.split("#")[0] + "#" + b; r ? history[s ? "replaceState" : "pushState"]("", c.title, d) : s ? u.replace(d) : u.hash = b, s = !0 }, y = function () { r ? history.pushState("", c.title, u.pathname + u.search) : u.hash = "", clearTimeout(t) }, z = function () { s ? t = setTimeout(x, 800) : x() }, A = "simplelb", B = a("<div>").addClass("sl-overlay"), C = a("<button>").addClass("sl-close").html('<i class="fa fa-times" aria-hidden="true"></i>'), D = a("<div>").addClass("sl-spinner").html("<div></div>"), E = a("<div>").addClass("sl-navigation").html('<button class="sl-prev">' + d.navText[0] + '</button><button class="sl-next">' + d.navText[1] + "</button>"), F = a("<div>").addClass("sl-counter").html('<span class="sl-current"></span>/<span class="sl-total"></span>'), G = !1, H = 0, I = a("<div>").addClass("sl-caption pos-" + d.captionPosition), J = a("<div>").addClass("sl-image"), K = a("<div>").addClass("sl-wrapper").addClass(d.className), L = function (b) { return !d.fileExt || "a" == a(b).prop("tagName").toLowerCase() && new RegExp(".(" + d.fileExt + ")$", "i").test(a(b).attr("href")) }, M = function () { d.close && C.appendTo(K), d.showCounter && o.length > 1 && (F.appendTo(K), F.find(".sl-total").text(o.length)), d.nav && E.appendTo(K), d.spinner && D.appendTo(K) }, N = function (b) { b.trigger(a.Event("show.simplelightbox")), d.disableScroll && (p = W("hide")), K.appendTo("body"), J.appendTo(K), d.overlay && B.appendTo(a("body")), G = !0, H = o.index(b), j = a("<img/>").hide().attr("src", b.attr("href")), m.indexOf(b.attr("href")) == -1 && m.push(b.attr("href")), J.html("").attr("style", ""), j.appendTo(J), R(), B.fadeIn("fast"), a(".sl-close").fadeIn("fast"), D.show(), E.fadeIn("fast"), a(".sl-wrapper .sl-counter .sl-current").text(H + 1), F.fadeIn("fast"), O(), d.preloading && T(), setTimeout(function () { b.trigger(a.Event("shown.simplelightbox")) }, d.animationSpeed) }, O = function (c) { if (j.length) { var e = new Image, f = a(b).width() * d.widthRatio, g = a(b).height() * d.heightRatio; e.src = j.attr("src"), a(e).bind("error", function (b) { o.eq(H).trigger(a.Event("error.simplelightbox")), G = !1, l = !0, D.hide(), d.alertError && alert(d.alertErrorMessage), U(1 == c || c == -1 ? c : 1) }), e.onload = function () { "undefined" != typeof c && o.eq(H).trigger(a.Event("changed.simplelightbox")).trigger(a.Event((1 === c ? "nextDone" : "prevDone") + ".simplelightbox")), d.history && z(), m.indexOf(j.attr("src")) == -1 && m.push(j.attr("src")); var h = e.width, i = e.height; if (h > f || i > g) { var k = h / i > f / g ? h / f : i / g; h /= k, i /= k } a(".sl-image").css({ top: (a(b).height() - i) / 2 + "px", left: (a(b).width() - h - p) / 2 + "px" }), D.hide(), j.css({ width: h + "px", height: i + "px" }).fadeIn("fast"), l = !0; var r, n = "self" == d.captionSelector ? o.eq(H) : o.eq(H).find(d.captionSelector); if (r = "data" == d.captionType ? n.data(d.captionsData) : "text" == d.captionType ? n.html() : n.prop(d.captionsData), d.loop || (0 === H && a(".sl-prev").hide(), H >= o.length - 1 && a(".sl-next").hide(), H > 0 && a(".sl-prev").show(), H < o.length - 1 && a(".sl-next").show()), 1 == o.length && a(".sl-prev, .sl-next").hide(), 1 == c || c == -1) { var s = { opacity: 1 }; d.animationSlide && (q ? (Q(0, 100 * c + "px"), setTimeout(function () { Q(d.animationSpeed / 1e3, "0px"), 50 })) : s.left = parseInt(a(".sl-image").css("left")) + 100 * c + "px"), a(".sl-image").animate(s, d.animationSpeed, function () { G = !1, P(r) }) } else G = !1, P(r); d.additionalHtml && 0 === a(".sl-additional-html").length && a("<div>").html(d.additionalHtml).addClass("sl-additional-html").appendTo(a(".sl-image")) } } }, P = function (b) { "" !== b && "undefined" != typeof b && d.captions && I.html(b).hide().appendTo(a(".sl-image")).delay(d.captionDelay).fadeIn("fast") }, Q = function (b, c) { var d = {}; d[k + "transform"] = "translateX(" + c + ")", d[k + "transition"] = k + "transform " + b + "s linear", a(".sl-image").css(d) }, R = function () { a(b).on("resize." + A, O), a(c).on("click." + A + " touchstart." + A, ".sl-close", function (a) { a.preventDefault(), l && V() }), d.history && setTimeout(function () { a(b).on("hashchange." + A, function () { if (l && v() === w) return void V() }) }, 40), E.on("click." + A, "button", function (b) { b.preventDefault(), h = 0, U(a(this).hasClass("sl-next") ? 1 : -1) }); var e = 0, f = 0, g = 0, j = 0, k = !1, m = 0; J.on("touchstart." + A + " mousedown." + A, function (a) { return !!k || (q && (m = parseInt(J.css("left"))), k = !0, e = a.originalEvent.pageX || a.originalEvent.touches[0].pageX, g = a.originalEvent.pageY || a.originalEvent.touches[0].pageY, !1) }).on("touchmove." + A + " mousemove." + A + " pointermove MSPointerMove", function (a) { return !k || (a.preventDefault(), f = a.originalEvent.pageX || a.originalEvent.touches[0].pageX, j = a.originalEvent.pageY || a.originalEvent.touches[0].pageY, h = e - f, i = g - j, void (d.animationSlide && (q ? Q(0, -h + "px") : J.css("left", m - h + "px")))) }).on("touchend." + A + " mouseup." + A + " touchcancel." + A + " mouseleave." + A + " pointerup pointercancel MSPointerUp MSPointerCancel", function (a) { if (k) { k = !1; var b = !0; d.loop || (0 === H && h < 0 && (b = !1), H >= o.length - 1 && h > 0 && (b = !1)), Math.abs(h) > d.swipeTolerance && b ? U(h > 0 ? 1 : -1) : d.animationSlide && (q ? Q(d.animationSpeed / 1e3, "0px") : J.animate({ left: m + "px" }, d.animationSpeed / 2)), d.swipeClose && Math.abs(i) > 50 && Math.abs(h) < d.swipeTolerance && V() } }) }, S = function () { E.off("click", "button"), a(c).off("click." + A, ".sl-close"), a(b).off("resize." + A), a(b).off("hashchange." + A) }, T = function () { var b = H + 1 < 0 ? o.length - 1 : H + 1 >= o.length - 1 ? 0 : H + 1, c = H - 1 < 0 ? o.length - 1 : H - 1 >= o.length - 1 ? 0 : H - 1; a("<img />").attr("src", o.eq(b).attr("href")).on("load", function () { m.indexOf(a(this).attr("src")) == -1 && m.push(a(this).attr("src")), o.eq(H).trigger(a.Event("nextImageLoaded.simplelightbox")) }), a("<img />").attr("src", o.eq(c).attr("href")).on("load", function () { m.indexOf(a(this).attr("src")) == -1 && m.push(a(this).attr("src")), o.eq(H).trigger(a.Event("prevImageLoaded.simplelightbox")) }) }, U = function (b) { o.eq(H).trigger(a.Event("change.simplelightbox")).trigger(a.Event((1 === b ? "next" : "prev") + ".simplelightbox")); var c = H + b; if (!(G || (c < 0 || c >= o.length) && d.loop === !1)) { H = c < 0 ? o.length - 1 : c > o.length - 1 ? 0 : c, a(".sl-wrapper .sl-counter .sl-current").text(H + 1); var e = { opacity: 0 }; d.animationSlide && (q ? Q(d.animationSpeed / 1e3, -100 * b - h + "px") : e.left = parseInt(a(".sl-image").css("left")) + -100 * b + "px"), a(".sl-image").animate(e, d.animationSpeed, function () { setTimeout(function () { var c = o.eq(H); j.attr("src", c.attr("href")), m.indexOf(c.attr("href")) == -1 && D.show(), a(".sl-caption").remove(), O(b), d.preloading && T() }, 100) }) } }, V = function () { if (!G) { var b = o.eq(H), c = !1; b.trigger(a.Event("close.simplelightbox")), y(), a(".sl-image img, .sl-overlay, .sl-close, .sl-navigation, .sl-image .sl-caption, .sl-counter").fadeOut("fast", function () { d.disableScroll && W("show"), a(".sl-wrapper, .sl-overlay").remove(), S(), c || b.trigger(a.Event("closed.simplelightbox")), c = !0 }), j = a(), l = !1, G = !1 } }, W = function (d) { var e = 0; if ("hide" == d) { var f = b.innerWidth; if (!f) { var g = c.documentElement.getBoundingClientRect(); f = g.right - Math.abs(g.left) } if (c.body.clientWidth < f) { var h = c.createElement("div"), i = parseInt(a("body").css("padding-right"), 10); h.className = "sl-scrollbar-measure", a("body").append(h), e = h.offsetWidth - h.clientWidth, a(c.body)[0].removeChild(h), a("body").data("padding", i), e > 0 && a("body").addClass("hidden-scroll").css({ "padding-right": i + e }) } } else a("body").removeClass("hidden-scroll").css({ "padding-right": a("body").data("padding") }); return e }; return M(), o.on("click." + A, function (b) { if (L(this)) { if (b.preventDefault(), G) return !1; N(a(this)) } }), a(c).on("click." + A + " touchstart." + A, function (b) { l && d.docClose && 0 === a(b.target).closest(".sl-image").length && 0 === a(b.target).closest(".sl-navigation").length && V() }), d.disableRightClick && a(c).on("contextmenu", ".sl-image img", function (a) { return !1 }), d.enableKeyboard && a(c).on("keyup." + A, function (a) { if (a.preventDefault(), h = 0, l) { var b = a.keyCode; 27 == b && V(), 37 != b && 39 != a.keyCode || U(39 == a.keyCode ? 1 : -1) } }), this.open = function (b) { b = b || a(this[0]), N(b) }, this.next = function () { U(1) }, this.prev = function () { U(-1) }, this.close = function () { V() }, this.destroy = function () { a(c).unbind("click." + A).unbind("keyup." + A), V(), a(".sl-overlay, .sl-wrapper").remove(), this.off("click") }, this.refresh = function () { this.destroy(), a(this.selector).SimpleLightbox(d) }, this } }(jQuery, window, document);

/*
A simple jQuery function that can add listeners on attribute change.
http://meetselva.github.io/attrchange/

About License:
Copyright (C) 2013-2014 Selvakumar Arumugam
You may use attrchange plugin under the terms of the MIT Licese.
https://github.com/meetselva/attrchange/blob/master/MIT-License.txt
 */
(function ($) {
    function isDOMAttrModifiedSupported() {
        var p = document.createElement('p');
        var flag = false;

        if (p.addEventListener) {
            p.addEventListener('DOMAttrModified', function () {
                flag = true
            }, false);
        } else if (p.attachEvent) {
            p.attachEvent('onDOMAttrModified', function () {
                flag = true
            });
        } else { return false; }
        p.setAttribute('id', 'target');
        return flag;
    }

    function checkAttributes(chkAttr, e) {
        if (chkAttr) {
            var attributes = this.data('attr-old-value');

            if (e.attributeName.indexOf('style') >= 0) {
                if (!attributes['style'])
                    attributes['style'] = {}; //initialize
                var keys = e.attributeName.split('.');
                e.attributeName = keys[0];
                e.oldValue = attributes['style'][keys[1]]; //old value
                e.newValue = keys[1] + ':'
                    + this.prop("style")[$.camelCase(keys[1])]; //new value
                attributes['style'][keys[1]] = e.newValue;
            } else {
                e.oldValue = attributes[e.attributeName];
                e.newValue = this.attr(e.attributeName);
                attributes[e.attributeName] = e.newValue;
            }

            this.data('attr-old-value', attributes); //update the old value object
        }
    }

    //initialize Mutation Observer
    var MutationObserver = window.MutationObserver
        || window.WebKitMutationObserver;

    $.fn.attrchange = function (a, b) {
        if (typeof a == 'object') {//core
            var cfg = {
                trackValues: false,
                callback: $.noop
            };
            //backward compatibility
            if (typeof a === "function") { cfg.callback = a; } else { $.extend(cfg, a); }

            if (cfg.trackValues) { //get attributes old value
                this.each(function (i, el) {
                    var attributes = {};
                    for (var attr, i = 0, attrs = el.attributes, l = attrs.length; i < l; i++) {
                        attr = attrs.item(i);
                        attributes[attr.nodeName] = attr.value;
                    }
                    $(this).data('attr-old-value', attributes);
                });
            }

            if (MutationObserver) { //Modern Browsers supporting MutationObserver
                var mOptions = {
                    subtree: false,
                    attributes: true,
                    attributeOldValue: cfg.trackValues
                };
                var observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (e) {
                        var _this = e.target;
                        //get new value if trackValues is true
                        if (cfg.trackValues) {
                            e.newValue = $(_this).attr(e.attributeName);
                        }
                        if (typeof $(this).data('attrchange-tdisconnect') === 'undefined') { //disconnected logically
                            cfg.callback.call(_this, e);
                        }
                    });
                });

                return this.data('attrchange-method', 'Mutation Observer')
                    .data('attrchange-obs', observer).each(function () {
                        observer.observe(this, mOptions);
                    });
            } else if (isDOMAttrModifiedSupported()) { //Opera
                //Good old Mutation Events
                return this.data('attrchange-method', 'DOMAttrModified').on('DOMAttrModified', function (event) {
                    if (event.originalEvent) { event = event.originalEvent; }//jQuery normalization is not required
                    event.attributeName = event.attrName; //property names to be consistent with MutationObserver
                    event.oldValue = event.prevValue; //property names to be consistent with MutationObserver
                    if (typeof $(this).data('attrchange-tdisconnect') === 'undefined') { //disconnected logically
                        cfg.callback.call(this, event);
                    }
                });
            } else if ('onpropertychange' in document.body) { //works only in IE
                return this.data('attrchange-method', 'propertychange').on('propertychange', function (e) {
                    e.attributeName = window.event.propertyName;
                    //to set the attr old value
                    checkAttributes.call($(this), cfg.trackValues, e);
                    if (typeof $(this).data('attrchange-tdisconnect') === 'undefined') { //disconnected logically
                        cfg.callback.call(this, e);
                    }
                });
            }
            return this;
        } else if (typeof a == 'string' && $.fn.attrchange.hasOwnProperty('extensions') &&
            $.fn.attrchange['extensions'].hasOwnProperty(a)) { //extensions/options
            return $.fn.attrchange['extensions'][a].call(this, b);
        }
    }
})(jQuery);

// query string parameters
jQuery.extend({
    getQueryParameters: function (str) {
        return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) { return n = n.split("="), this[n[0]] = n[1], this }.bind({}))[0];
    }
});

//Responsive tables
$(function () {
    $('table').each(function () {
        $(this).addClass('table').wrap("<div class='table-responsive'></div>");
    });
});

//FAQ Block
$(function () {
    $('.faq-list .faq-link').on('click', function (e) {
        e.preventDefault();
        $(this).siblings('.answer').addClass('open');
        $(this).attr('aria-expanded', 'true');
    });

    $('.close-answer').on('click', function () {
        $(this).parent('.answer').removeClass('open');
        $(this).parent('.answer').siblings('a').attr('aria-expanded', 'false');
    });

    $(document).mouseup(function (e) {
        var container = $(".answer");

        // If the target of the click isn't the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.faq-list a').attr('aria-expanded', 'false');
            $('.faq-list .answer').removeClass('open');
        }

    });
});

$(function () {
    $('.copy-link').on('click', function (e) {
        e.preventDefault();
        const content = $(this).parent('.share').siblings('.content').text().trim();
        navigator.clipboard.writeText(content);
    });
});

//.boflatestcontentblock
$(function () {
    $('.boflatestcontentblock #show-more-latest').on('click', function () {
        let counter = 0;
        $(this).parents('.row').siblings('.content').children('.col-md-4:hidden').each(function () {
            counter++;
            if (counter < 7) {
                $(this).show();
            } else {
                return false;
            }
            
        });
        if ($(this).parents('.row').siblings('.content').children('.col-md-4:hidden').length === 0) {
            $(this).hide();
        } 
    });
});

$(function () {
    $('.blog-articles .show-more').on('click', function () {
        let counter = 0;
        $(this).parent('.col-12').siblings('.col-lg-4:hidden').each(function () {
            counter++;
            if (counter < 7) {
                $(this).show();
            } else {
                return false;
            }

        });
        if ($(this).parent('.col-12').siblings('.col-lg-4:hidden').length === 0) {
            $(this).hide();
        }
    });
});

/*************************************************************/
/************ NO OWN FUNCTIONS AFTER THIS LINE ***************/
/********** YES, DON'T WRITE ANYTHING AFTER THIS *************/
/*************************************************************/
/*********************** ...REALLY ***************************/
/*************************************************************/